import {PermsMap} from './types';

import {AuthenticatedUserSerializedType} from 'sweet-types';

export function getCurrentUserPerms(
  data: AuthenticatedUserSerializedType | undefined
): PermsMap {
  if (data == null) {
    return {
      canAssignTasks: false,
      isManager: false,
      isSuperManager: false,
      isTeamMember: false,
      isSuper: false,
      isOwner: false,
      isSamlOnly: false,
    };
  }

  const {
    can_assign_tasks,
    is_manager,
    is_super_manager,
    is_super_teammate,
    is_owner,
    team_memberships,
    restrict_saml_only_login,
  } = data;

  return {
    canAssignTasks: can_assign_tasks,
    isManager: is_manager,
    isSuperManager: is_super_manager,
    isTeamMember:
      team_memberships.filter((m) => m.access !== 'reader').length > 0 ||
      is_manager ||
      is_super_teammate,
    isSuper: is_super_manager || is_super_teammate || false,
    isOwner: is_owner,
    isSamlOnly: restrict_saml_only_login,
  };
}
